export default __webpack_public_path__ + "static/media/1_1.c4e097fc.jpg";